import { environmentDev } from './environment-dev'
import { environmentProd } from './environment-prod'
import { IEnvironmentFromFile } from './environment.types'
import { EPHEMERAL_SEARCH_SANDBOX, resolveSearchServiceUrl } from './sandboxes'

const stageName = process.env['STAGE_NAME']
const baseEnvironment: IEnvironmentFromFile =
  stageName === 'production' ? environmentProd : environmentDev

export const environment: IEnvironmentFromFile = {
  ...baseEnvironment,
  SEARCH_SERVICE_URL: resolveSearchServiceUrl(
    stageName,
    EPHEMERAL_SEARCH_SANDBOX,
    baseEnvironment.SEARCH_SERVICE_URL,
  ),
}
